import { BANNER_CONSTANTS } from "@/shared/config";
import { cn } from "@/shared/lib/utils";
import { AspectRatio } from "@/shared/ui/layout/aspect-ratio";
import { SafeBanner } from "@/shared/ui/data-display/safe-banner";

interface CardBannerProps {
  src?: string | null;
  alt?: string;
  className?: string;
  overlayClassName?: string;
  children?: React.ReactNode;
  /** Бренд-градиент + GL-знак, если обложки нет (см. SafeBanner.brandFallback). */
  brandFallback?: boolean;
  /** Проигрывать анимированные GIF (иначе замораживаются в статичный кадр). */
  allowAnimatedGif?: boolean;
  /** LCP-образ маршрута: грузить сразу и с высоким приоритетом (KAN-977). */
  priority?: boolean;
}

export function CardBanner({
  src,
  alt,
  className,
  overlayClassName,
  children,
  brandFallback = false,
  allowAnimatedGif = false,
  priority = false,
}: CardBannerProps) {
  return (
    <div className={cn("relative w-full overflow-hidden bg-muted", className)}>
      <AspectRatio ratio={BANNER_CONSTANTS.ASPECT_RATIO} className="w-full">
        <SafeBanner
          src={src ?? null}
          {...(alt ? { alt } : {})}
          fill
          rounded="rounded-none"
          brandFallback={brandFallback}
          allowAnimatedGif={allowAnimatedGif}
          priority={priority}
        />
        <div
          className={cn(
            "pointer-events-none absolute inset-0 bg-black/40",
            overlayClassName,
          )}
        />
        {children}
      </AspectRatio>
    </div>
  );
}

